import { z } from 'zod';

export const clientPresentationSchema = z.object({
    mildLow: z
        .array(
            z.enum([
                'Appropriate',
                'Calm',
                'Content',
                'Contemplative',
                'Engaged',
                'Expressive',
                'Focused',
                'Insightful',
                'Mindful',
                'Pleasant',
                'Oriented',
                'Quiet',
                'Talkative',
                'Tired',
                'WNR',
            ]),
        )
        .optional(),
    mildLowOther: z.string().trim().optional(),
    moderate: z
        .array(
            z.enum([
                'Argumentative',
                'Apathetic',
                'Ashamed',
                'Distracted',
                'Frustrated',
                'Guarded',
                'Indecisive',
                'Irritable',
                'Lethargic',
                'Overwhelmed',
                'Pessimistic',
                'Restless',
                'Rigid thinking',
                'Sad',
                'Tearful',
            ]),
        )
        .optional(),
    moderateOther: z.string().trim().optional(),
    highSevere: z
        .array(
            z.enum([
                'Agitated',
                'Defensive',
                'Depressed',
                'Dissociated',
                'Euphoric',
                'Fearful',
                'Flat affect',
                'Grandiose',
                'Hypervigilant',
                'Inappropriate',
                'Incongruence',
                'Intense',
                'Labile',
                'Shaking',
                'Yelling',
                'Withdrawn',
            ]),
        )
        .optional(),
    highSevereOther: z.string().trim().optional(),
});
